export default __webpack_public_path__ + "static/media/logo-regenesis-white.d19bce45.svg";